import DefaultFormField from "../defaultFields/formField"

export default class FormField extends DefaultFormField {

}
